'use strict';

class PlayMedia {

    constructor() {
        this.keyVisual = document.querySelector('.key-visual-home');

        if (this.keyVisual) {
            let videos = this.keyVisual.querySelectorAll('video');
            let playPromises = 0;

            if (videos.length > 0) {

                for (let video of videos) {
                    let playPromise = video.play();

                    if (playPromise !== undefined) {
                        playPromise
                            .then(_ => {
                                video.pause();
                                playPromises++;
                            })
                            .catch(error => {
                                console.log(error, video);
                            });
                    }
                }

                //  Require module only if there is a Media slider requested
                const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

                let swiper = new Swiper(this.keyVisual.querySelector('.swiper-container'), {
                    preventInteractionOnTransition: true,
                    allowTouchMove: false,
                    simulateTouch: false,
                    effect: 'fade',
                    init: false,
                    loop: true,
                    speed: 800,
                    slidesPerView: 1,
                    watchOverflow: true,
                    navigation: {
                        nextEl: this.keyVisual.querySelector('.next-slide'),
                        prevEl: this.keyVisual.querySelector('.prev-slide')
                    },
                    pagination: {
                        el: this.keyVisual.querySelector('.list'),
                        clickable: false,
                        bulletClass: 'bullet',
                        bulletActiveClass: 'active',
                        renderBullet: (index, className) => {

                            let title = this.keyVisual.querySelector(`[data-swiper-slide-index="${index}"]`);

                            return `<li class="${className}"><span class="title">${title ? title.dataset.title : ''}</span></li>`;
                        }
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 16
                        }
                    }
                });

                swiper.on('slideNextTransitionEnd', () => {

                    let currentSlide = this.keyVisual.querySelector('.swiper-slide-active');
                    this.playSlide(currentSlide);
                });

                swiper.init();
            }
        }
    }

    playSlide(currentSlide) {

        let swiper = document.querySelector('.swiper-container').swiper;
        let currentVideo = currentSlide.querySelector('video');
        let playPromise = currentVideo.play();

        if (playPromise !== undefined) {
            playPromise
                .then(_ => {
                    currentVideo.play();
                    currentVideo.addEventListener('ended', function () {
                        swiper.slideNext();
                    },false);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
}

module.exports = PlayMedia;
